import { brand } from '@ipfabric/utils';
import type {
  DeviceViewLabelsEntityId,
  DeviceViewLabelsTab,
} from '../deviceViewTypes';

const compareStrings = (left: string, right: string): number =>
  left < right ? -1 : left > right ? 1 : 0;

const getSortedTargetKeys = (labelsTabs: DeviceViewLabelsTab[]): string[] =>
  Array.from(
    new Set(labelsTabs.map((tab) => JSON.stringify([tab.type, tab.id]))),
  ).sort(compareStrings);

export const getLabelsTargetsKey = (
  labelsTabs: DeviceViewLabelsTab[],
): string => JSON.stringify(getSortedTargetKeys(labelsTabs));

export const getDeviceViewLabelsEntityId = (
  labelsTabs: DeviceViewLabelsTab[],
): DeviceViewLabelsEntityId | null => {
  const targetsKey = getLabelsTargetsKey(labelsTabs);
  return targetsKey === '[]'
    ? null
    : brand<DeviceViewLabelsEntityId>(`labels:${targetsKey}`);
};
